import { request } from '../../auth/api.ts';

/**
 * The operator metrics page's API client. Deliberately its own small module
 * rather than folded into `auth/api.ts` — this is not part of the ordinary
 * sign-in flow and nothing here is imported by a screen a trainee ever sees.
 */

export type EntryKind = 'case' | 'procedure' | 'edt' | 'anaesthetic';

export type AdminMetrics = {
  generatedAt: string;
  accounts: {
    total: number;
    signupsPerWeek: { weekStarting: string; count: number }[];
    signupsPerMonth: { month: string; count: number }[];
    cumulative: { month: string; total: number }[];
    entryCountBands: { band: string; accounts: number }[];
  };
  traffic: {
    activeLast7Days: number;
    activeLast30Days: number;
    activeLast90Days: number;
    /** Aggregate across every account, Monday-aligned — same shape `dailyActivity` returns. */
    entriesPerDay: { date: string; count: number }[];
    retention90dSignupVs30dActive: { eligible: number; active: number };
  };
  features: {
    entryKindCounts: Record<EntryKind, number>;
    topCaseTypes: { key: string; count: number }[];
    topProcedures: { key: string; count: number }[];
    topEdtActivities: { key: string; count: number }[];
  };
};

export const adminApi = {
  async unlock(pin: string): Promise<void> {
    await request<void>('/api/admin/unlock', { method: 'POST', body: JSON.stringify({ pin }) });
  },

  async lock(): Promise<void> {
    await request<void>('/api/admin/lock', { method: 'POST' });
  },

  async metrics(): Promise<AdminMetrics> {
    return request<AdminMetrics>('/api/admin/metrics');
  },
};
